export default "__VITE_ASSET__eHD6riyF__"